// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"134f4742","56":"c11d80b1","79":"4ed7d0d4","135":"f34dbad4","231":"ca45ce11","259":"ae469255","264":"3e240096","288":"c6a8cc73","426":"566212f9","511":"329bb5c4","883":"fcbe081c","915":"1b2c904c"}[chunkId] + ".chunk.js";
};